<!--page container-->
<span defaultOverlayTarget></span>
<!-- progress bar -->
<ng-progress></ng-progress>
<!-- primary outlet -->
<router-outlet></router-outlet>

<!--top navbar-->
<nav class="mvd_navbar print--hidden" role="navigation">
    <ul class="mvd_navbar__container">
        <li class="mvd_navbar__left">
            <ul class="mvd_navbar__left__list">
                <li class="mvd_navbar__left__burger" *ifHasBusinessUnit="true">
                    <div id="burger" class="dropdown">
                        <button role="button" title="Menu" type="button" id="burgerButton" (click)="showMegaMenuToggle()"></button>
                    </div>
                </li>
                <li class="mvd_navbar__left__logo">
                    <a href="javascript:void(0);" title="Dashboard - Home" [routerLink]="['/']">ADOT</a>
                </li>
                <li class="mvd_navbar__left__search" *ifHasBusinessUnit="true">
                    <navbar-search [routerUrl]="router.url" *ngIf="isAllowViewOmniSearchBar"
                        (onNavigateRequest)="navigateToRoute($event)">
                    </navbar-search>
                </li>
            </ul>
        </li>

        <li class="mvd_navbar__right">
            <right-nav-bar></right-nav-bar>
        </li>
    </ul>
</nav>

<div class="nav--mega--container" id="mega-menu"
    [class.open]="showMegaMenu"
    clickOutsideDirective
    (clickOutside)="isItAnOutsideClickHandler($event)">
    <mega-menu
        [currentMegaMenuIndex]="currentMegaMenuIndex"
        [menuItems]="menuItems"
        (onSelectRoute)="routeSelected()"
        (onSelectService)="selectedService($event)"
        (onShowMegaMenuToggle)="showMegaMenuToggle()"
        (onStartTransaction)="startTransaction($event)"></mega-menu>
</div>
